
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/errors/invalid-result",
      function () {
        return require("private-next-pages/docs/errors/invalid-result.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/errors/invalid-result"])
      });
    }
  